import enCurator from './en';
import ruCurator from './ru';

export default {
  en: {
    ...enCurator,
  },
  ru: {
    ...ruCurator,
  },
};
